import { Typography } from '@mui/material';
import React, { Component } from 'react';
import Basic from '../../container/layouts/Basic';
import EmployeeSalaryList from '../EmployeeView/EmployeeSalaryList';

class UserSalaryList extends Component {
    state = { }

    render() {
        return (
            <Basic salaries {...this.props}>
                <Typography variant="h4">Salaires</Typography>
                <EmployeeSalaryList {...this.props} />
            </Basic>
        );
    }
}

export default UserSalaryList;